import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAppInstanceConfigs } from 'store/app-instance-configs/selectors';
import { useSearchParams } from './use-search-params.hook';
import { searchParams } from 'pages/date-select-page/interface';
import { updateCurrentAppInstanceConfigUuid } from 'store/app-instance-configs/actions';
import { selectBuilding } from 'store/building/selectors';

export const useDefaultAppInstanceConfigUuid = (): void => {
  const dispatch = useDispatch();
  const { appInstanceConfigUUID } = useSearchParams<searchParams>();
  const appInstancesConfigs = useSelector(selectAppInstanceConfigs);
  const building = useSelector(selectBuilding);

  useEffect(() => {
    if (appInstanceConfigUUID && !appInstancesConfigs.length && !building) {
      dispatch(updateCurrentAppInstanceConfigUuid({ currentAppInstanceConfigUuid: appInstanceConfigUUID }));
    }
  }, [appInstanceConfigUUID, dispatch, appInstancesConfigs, building]);
};
